/**
 * Created by laugh on 8/24/2017.
 */
import React, { Component } from 'react';
import $ from 'jquery';
import logo from '../../assets/img/mealtrist-logo.png';
import { Link } from 'react-router-dom';
import * as ReactBootstrap from 'react-bootstrap';
import '../../App.css';

class MealtristHeader extends React.Component {
    constructor(props) {
        super(props);
        console.log(props.testing);
        this.state = {profileId: "", redirecting: false, provider: "cox", leadSource: "500", tfn: "772-452-4565", text: "The TransactionID is "};
    }

    componentWillMount() {
        var globalThis = this;
        const user = {
            id: localStorage.getItem('profileId'),
            token: ""
        };
        user.token = localStorage.getItem("mealToken");
        if(user.token && (user.id === "" || !user.id || user.id === null)) {
            //TESTING COMPLETE ORDERS
            $.ajax({
                url: process.env.REACT_APP_API_HOST + '/' + 'api/auth/user',
                type: 'get',
                async: false,
                'headers': {
                    // Use access_token previously retrieved from inContact token
                    // service.
                    'Authorization': 'Bearer ' + user.token,
                },
                error: function (response) {
                    //Failed response
                    // logOrderError(visitID, 'otsError', completeOrderData, response);
                },
                success: function (response) {
                    if(typeof(response.message) !== 'undefined') {
                        if(response.message.indexOf('authenticated_user') > -1) {
                            if (typeof(response.data) !== 'undefined') {
                                if (typeof(response.data.id) !== 'undefined') {
                                    globalThis.setState(prevState => ({
                                        profileId: response.data.id
                                    }));
                                    localStorage.setItem('profileId', response.data.id );
                                } else {
                                    globalThis.setState(prevState => ({
                                        loggedIn: false
                                    }));
                                }
                            }
                        }
                    }
                }
            });
        } else {
            globalThis.setState(prevState => ({
                profileId: user.id
            }));
        }

    }

    //TODO set referrer url link in containers first child link
    render() {
        let profileLink = "";
        if(this.state.profileId !== "" ) {
            profileLink =
                    <ReactBootstrap.NavItem eventKey={7} href="#">
                        <Link to={'/profile/' + this.state.profileId} >Profile</Link>
                    </ReactBootstrap.NavItem>
        }
        let output = "";

        output = <div>
            <header>
                <div className="container">
                    <div className="row">
                        <ReactBootstrap.Navbar fluid collapseOnSelect>
                            <ReactBootstrap.Navbar.Header>
                                <ReactBootstrap.Navbar.Brand>
                                    <a><img className="img-responsive" height="60" width="60" src={logo} alt="mealtrist-logo" /></a>
                                </ReactBootstrap.Navbar.Brand>
                                <ReactBootstrap.Navbar.Toggle />
                            </ReactBootstrap.Navbar.Header>
                            <ReactBootstrap.Navbar.Collapse>
                                <ReactBootstrap.Nav>
                                    <ReactBootstrap.NavItem eventKey={1} href="#">
                                        <Link to="/feed">Mealtrist Feed</Link>
                                    </ReactBootstrap.NavItem>
                                    <ReactBootstrap.NavItem eventKey={2} href="#">
                                        <Link to="/saved" >Saved Recipes</Link>
                                    </ReactBootstrap.NavItem>
                                    <ReactBootstrap.NavItem eventKey={3} href="#">
                                        <Link to="/plan" >Plan</Link>
                                    </ReactBootstrap.NavItem>
                                    <ReactBootstrap.NavItem eventKey={4} href="#">
                                        <Link to="/connections" >Connections</Link>
                                    </ReactBootstrap.NavItem>
                                    <ReactBootstrap.NavItem eventKey={5} href="#">
                                        <Link to="/add-meal" >+ Meal</Link>
                                    </ReactBootstrap.NavItem>
                                    {/*<ReactBootstrap.NavDropdown eventKey={6} title="Dropdown" id="basic-nav-dropdown">*/}
                                    {/*<ReactBootstrap.MenuItem eventKey={6.1}>Action</ReactBootstrap.MenuItem>*/}
                                    {/*<ReactBootstrap.MenuItem eventKey={6.2}>Another action</ReactBootstrap.MenuItem>*/}
                                    {/*<ReactBootstrap.MenuItem eventKey={6.3}>Something else here</ReactBootstrap.MenuItem>*/}
                                    {/*<ReactBootstrap.MenuItem divider />*/}
                                    {/*<ReactBootstrap.MenuItem eventKey={6.4}>Separated link</ReactBootstrap.MenuItem>*/}
                                    {/*</ReactBootstrap.NavDropdown>*/}
                                </ReactBootstrap.Nav>
                                <ReactBootstrap.Nav pullRight>
                                    {this.state.profileId !== "" &&
                                     profileLink
                                    }
                                    <ReactBootstrap.NavItem eventKey={8} href="#">
                                        <Link to="/" >Logout</Link>
                                    </ReactBootstrap.NavItem>
                                </ReactBootstrap.Nav>
                            </ReactBootstrap.Navbar.Collapse>
                        </ReactBootstrap.Navbar>
                    </div>
                </div>
            </header>
        </div>;

        return (
            <div>
            {output}
            </div>
        );
    }
}

export default MealtristHeader;


// WEBPACK FOOTER //
// ./src/components/Core/mealtristHeader.js